enum GTMEventCategory {
  FilterChange = 'filter',
  Click = 'click',
  Download = 'download',
  ChangeModelImage = 'change-model-image',
  ChangeConfiguration = 'configuration',
  ChangeConfigurationStep = 'configuration-flow',
  Change = 'change',
  Error = 'error',
  StoreSearch = 'store-search',
  StoreSearchLocationRequest = 'store-search-location-request',
  StoreSearchZipRequest = 'store-search-zip-request',
  StoreSearchRadius = 'store-search-radius',
  StoresMapPin = 'stores-map-pin',
  StoreForm = 'store-form',
}

export default GTMEventCategory;
